import { CommonCallout } from 'components/common/callouts';
import { ErrorBoundary } from 'components/common/error-boundary';
import { CommonTabs } from 'components/common/tabs';
import { ArchivedLogsTab } from 'components/sections/admin-portal/machines/dialogs/settings/machine-logs/archived-logs.tab';
import { LiveLogsTab } from 'components/sections/admin-portal/machines/dialogs/settings/machine-logs/live-logs.tab';
import { useMachinesPortalStore } from 'components/sections/admin-portal/machines/store/use-machines-portal-store';
import { StringHelper } from 'lib_ts/classes/string.helper';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { useState } from 'react';

enum TabKey {
  LiveLogs = 'LiveLogs',
  ArchivedLogs = 'ArchivedLogs',
}

export const MachineLogs = () => {
  const [activeTab, setActiveTab] = useState<TabKey>(TabKey.LiveLogs);
  const machine = useMachinesPortalStore((s) => s.machine);

  return (
    <ErrorBoundary identifier="MachineLogs">
      <CommonTabs
        value={activeTab}
        onValueChange={(value) => setActiveTab(value as TabKey)}
        className={StringHelper.classNames([RADIX.VFLEX.GROW, 'flex-column'])}
        contentClassName={StringHelper.classNames([
          RADIX.VFLEX.GROW,
          'flex-column',
        ])}
        tabs={[
          {
            value: TabKey.LiveLogs,
            label: 'Live Logs',
            content: machine?.connected ? (
              <LiveLogsTab />
            ) : (
              <CommonCallout text="Live logs only available for connected machines." />
            ),
          },
          {
            value: TabKey.ArchivedLogs,
            label: 'Archived Logs',
            content: <ArchivedLogsTab />,
          },
        ]}
        gap="0"
      />
    </ErrorBoundary>
  );
};
